import React from "react";
import Home from "./components/home/Home";
import PortfolioCard from "./components/portfolioCard/PortfolioCard";
import Navbar from "./components/navbar/Navbar";
import Project from "./components/project/Project";
import Chat from "./components/chat/Chat";

function App() {
  return (
    // <div className="gap-12 md:flex md:items-start md:mx-16 xl:mx-48">
    //   <aside className="md:sticky h-full md:w-1/3 lg:w-1/4 md:top-10 md:z-[1] min-w-[400px]">
    //     <PortfolioCard />
    //   </aside>
    //   <main className="relative p-auto">
    //     <Home />
    //     <Contact />
    //   </main>
    //   <Navbar/>
    // </div>


    <div className="grid h-screen grid-cols-1 gap-8 pt-12 grid-row-2 md:grid-cols-3 xl:grid-cols-4" style={{ 'grid-template-rows': 'auto 80px' }}>
      <aside className="overflow-hidden scrollbar-none md:col-span-1">
        <PortfolioCard />
      </aside>
      <main className="overflow-y-scroll md:col-span-2 xl:col-span-3 no-scroll">
        <Home />
        <div className="h-4" />
        <Project />
      </main>
      <div className="md:col-span-3 xl:col-span-4">
        <Navbar />
      </div>
      <Chat />
    </div>
  );
}

export default App;
